(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["discount_bar_2nd_bag"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sentier-bag-picker')) {
    class SentierBagPicker extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onVariantUpdate = this.onVariantUpdate.bind(this);
        this.onRootChange = this.onRootChange.bind(this);
        this.render = this.render.bind(this);
        this.root = null;
        this.selectedId = null;
        this.grindTouched = false;
        this.chosenGrind = null;
        this.lastMainTitle = null;
        this.busy = false;
        this.timers = [];
        this.addedTimer = null;
        this.errorTimer = null;
        this.io = null;
        this.entranceDone = false;
        this.hinted = false;
        this.userTouched = false;
        this.lastShown = null;
        this.cartCoffee = null;
        this.cartMin = null;
        this.cartIds = null;
        this.onPointerDown = () => {
          this.userTouched = true;
        };
      }

      connectedCallback() {
        try {
          this.mainVariants = JSON.parse(this.dataset.mainVariants || '{}') || {};
        } catch (error) {
          this.mainVariants = {};
        }

        const initial = this.querySelector('[data-sbp-tile].is-selected') || this.querySelector('[data-sbp-tile]');
        if (initial && !this.selectedId) this.selectedId = initial.dataset.productId;

        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        document.addEventListener('variant:update', this.onVariantUpdate);
        this.onCartChanged =
          this.onCartChanged ||
          ((event) => {
            if (event && event.promise && typeof event.promise.then === 'function') {
              event.promise.then(
                () => this.queueCartRefresh(),
                () => this.queueCartRefresh()
              );
            } else {
              this.queueCartRefresh();
            }
          });
        document.addEventListener('cart:update', this.onCartChanged);
        document.addEventListener('shopify:cart:lines-update', this.onCartChanged);
        window.addEventListener('pageshow', this.onCartChanged);
        this.loadCartEvents();
        this.refreshCart();

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.fit());
          this.resizeObserver.observe(this);
        }
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.fit());

        this.reduceMotion = Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        this.addEventListener('pointerdown', this.onPointerDown);

        this.attachRoot();
        this.render();
        this.setupEntrance();
        this.schedule(300);
        this.schedule(1200);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('pointerdown', this.onPointerDown);
        if (this.io) this.io.disconnect();
        this.io = null;
        document.removeEventListener('variant:update', this.onVariantUpdate);
        if (this.onCartChanged) {
          document.removeEventListener('cart:update', this.onCartChanged);
          document.removeEventListener('shopify:cart:lines-update', this.onCartChanged);
          window.removeEventListener('pageshow', this.onCartChanged);
        }
        clearTimeout(this.cartTimer);
        this.detachRoot();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.resizeObserver = null;
        this.timers.forEach((timer) => clearTimeout(timer));
        this.timers = [];
        clearTimeout(this.addedTimer);
        clearTimeout(this.errorTimer);
      }

      schedule(delay) {
        this.timers.push(
          setTimeout(() => {
            this.attachRoot();
            this.render();
          }, delay)
        );
      }

      findRoot() {
        let node = this.parentElement;
        while (node && node !== document.body) {
          if (node.querySelector('form[action*="/cart/add"]')) return node;
          node = node.parentElement;
        }
        return null;
      }

      attachRoot() {
        if (this.root && this.root.isConnected) return;
        this.detachRoot();
        const root = this.findRoot();
        if (!root) return;
        this.root = root;
        root.addEventListener('change', this.onRootChange);
      }

      detachRoot() {
        if (!this.root) return;
        this.root.removeEventListener('change', this.onRootChange);
        this.root = null;
      }

      mainForm() {
        if (!this.root) return null;
        const forms = Array.from(this.root.querySelectorAll('form[action*="/cart/add"]'));
        return forms.find((form) => Array.from(form.elements).some((el) => el.name === 'id')) || null;
      }

      mainGrindTitle() {
        const form = this.mainForm();
        if (form) {
          const field = Array.from(form.elements).find((el) => el.name === 'id');
          const entry = field ? this.mainVariants[String(field.value)] : null;
          if (entry) return typeof entry === 'string' ? entry : entry.title;
        }
        return this.lastMainTitle || this.dataset.mainTitle || null;
      }

      mainItem() {
        const form = this.mainForm();
        if (!form) return null;
        let formData;
        try {
          formData = new FormData(form);
        } catch (error) {
          return null;
        }
        const id = Number(formData.get('id'));
        if (!id) return null;
        const entry = this.mainVariants[String(id)];
        if (entry && typeof entry === 'object' && entry.available === false) return null;

        const item = { id: id, quantity: Math.max(1, parseInt(formData.get('quantity'), 10) || 1) };
        const plan = formData.get('selling_plan');
        if (plan && String(plan).trim() !== '') item.selling_plan = Number(plan);

        const properties = {};
        formData.forEach((value, key) => {
          const match = /^properties\[(.+)\]$/.exec(key);
          if (match && typeof value === 'string' && value !== '') properties[match[1]] = value;
        });
        if (Object.keys(properties).length) item.properties = properties;
        return item;
      }

      mainUnitCents(item) {
        const main = item || this.mainItem();
        if (!main) return null;
        const entry = this.mainVariants[String(main.id)];
        if (!entry || typeof entry !== 'object') return null;
        if (main.selling_plan && entry.plans && entry.plans[String(main.selling_plan)] != null) {
          return Number(entry.plans[String(main.selling_plan)]);
        }
        return entry.price != null ? Number(entry.price) : null;
      }

      eligibleIds() {
        if (!this._eligible) {
          this._eligible = new Set(
            String(this.dataset.eligibleIds || '')
              .split(',')
              .map((id) => id.trim())
              .filter(Boolean)
          );
        }
        return this._eligible;
      }

      async refreshCart() {
        try {
          this.setCartCoffee(await this.fetchCart());
        } catch (error) {
          this.cartCoffee = null;
          this.cartMin = null;
          this.applyMode();
        }
      }

      queueCartRefresh() {
        clearTimeout(this.cartTimer);
        this.cartTimer = setTimeout(() => this.refreshCart(), 250);
      }

      isBundle() {
        return this.dataset.bundle === 'true' && this.cartCoffee === 0 && Boolean(this.mainItem());
      }

      savingsCents(variant, bundle) {
        if (!variant) return 0;
        const prices = [Number(variant.price)];
        if (bundle) {
          const main = this.mainUnitCents();
          if (main != null) prices.push(main);
        } else if (this.cartMin != null) {
          prices.push(this.cartMin);
        }
        const valid = prices.filter((price) => isFinite(price) && price > 0);
        if (!valid.length) return 0;
        return Math.round(Math.min.apply(null, valid) / 2);
      }

      formatMoney(cents) {
        const value = Math.max(0, Math.round(Number(cents) || 0));
        const format = this.dataset.moneyFormat || '${{amount}}';
        const group = (decimals, thousands, decimal) => {
          const parts = (value / 100).toFixed(decimals).split('.');
          const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return parts[1] ? whole + decimal + parts[1] : whole;
        };
        const match = /\{\{\s*(\w+)\s*\}\}/.exec(format);
        if (!match) return '$' + (value / 100).toFixed(2);
        let amount;
        switch (match[1]) {
          case 'amount_no_decimals':
            amount = group(0, ',', '.');
            break;
          case 'amount_with_comma_separator':
            amount = group(2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            amount = group(0, '.', ',');
            break;
          case 'amount_with_apostrophe_separator':
            amount = group(2, "'", '.');
            break;
          case 'amount_no_decimals_with_space_separator':
            amount = group(0, ' ', '');
            break;
          case 'amount_with_space_separator':
            amount = group(2, ' ', ',');
            break;
          case 'amount_with_period_and_space_separator':
            amount = group(2, ' ', '.');
            break;
          default:
            amount = group(2, ',', '.');
        }
        return format.replace(match[0], amount);
      }

      applyMode() {
        const bundle = this.isBundle();
        this.classList.toggle('is-bundle', bundle);
        const tile = this.selectedTile();
        const note = this.querySelector('[data-sbp-note]');
        const save = this.querySelector('[data-sbp-save]');
        const full = this.querySelector('[data-sbp-full]');
        const half = this.querySelector('[data-sbp-half]');
        const variant = tile ? this.currentVariant(tile) : null;
        const pick = tile ? tile.dataset.productTitle || '' : '';
        const thisTitle = this.dataset.thisTitle || '';
        const savings = this.savingsCents(variant, bundle);

        const setText = (el, text) => {
          if (el && el.textContent !== text) el.textContent = text;
        };

        if (variant) {
          setText(full, variant.full || this.formatMoney(variant.price));
          setText(half, this.formatMoney(Number(variant.price) - savings));
        }
        if (save) {
          setText(save, savings > 0 ? (this.dataset.textSave || 'Save') + ' ' + this.formatMoney(savings) : '');
          save.hidden = savings <= 0;
        }
        if (note) {
          const text = String(this.dataset.textNote || '')
            .replace(/\[this\]/g, () => thisTitle)
            .replace(/\[pick\]/g, () => pick);
          note.textContent = text;
          note.hidden = !bundle || !text;
        }
        this.fit();
      }

      tiles() {
        return Array.from(this.querySelectorAll('[data-sbp-tile]'));
      }

      selectedTile() {
        const tiles = this.tiles();
        return tiles.find((tile) => tile.dataset.productId === this.selectedId) || tiles[0] || null;
      }

      variantsOf(tile) {
        if (!tile) return [];
        try {
          return JSON.parse(tile.dataset.variants || '[]') || [];
        } catch (error) {
          return [];
        }
      }

      pickVariant(variants) {
        const available = variants.filter((variant) => variant.available);
        const byTitle = (title) => {
          if (!title) return null;
          const wanted = String(title).trim().toLowerCase();
          return available.find((variant) => String(variant.title).trim().toLowerCase() === wanted) || null;
        };
        return (this.grindTouched && byTitle(this.chosenGrind)) || byTitle(this.mainGrindTitle()) || available[0] || variants[0] || null;
      }

      currentVariant(tile) {
        const variants = this.variantsOf(tile);
        const select = this.querySelector('[data-sbp-select]');
        if (select && select.value) {
          const match = variants.find((variant) => String(variant.id) === String(select.value));
          if (match) return match;
        }
        return this.pickVariant(variants);
      }

      render() {
        if (!this.isConnected) return;
        const tile = this.selectedTile();
        if (!tile) return;
        this.selectedId = tile.dataset.productId;

        this.tiles().forEach((item) => {
          const on = item === tile;
          item.classList.toggle('is-selected', on);
          item.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        if (this.cartIds) this.syncInCart(this.cartIds);
        this.buildSelect(tile);
        this.updateButton(tile);
      }

      syncInCart(ids) {
        const label = this.dataset.textInCart || 'In cart';
        this.tiles().forEach((tile) => {
          const on = ids.has(tile.dataset.productId);
          const title = tile.dataset.productTitle || '';
          tile.classList.toggle('is-in-cart', on);
          const aria = on ? title + ', ' + label : title;
          if (tile.getAttribute('aria-label') !== aria) tile.setAttribute('aria-label', aria);
        });
      }

      buildSelect(tile) {
        const select = this.querySelector('[data-sbp-select]');
        const wrap = this.querySelector('[data-sbp-select-wrap]');
        if (!select) return;

        const variants = this.variantsOf(tile);
        const sameProduct = select.dataset.product === tile.dataset.productId && select.options.length === variants.length;

        if (!sameProduct) {
          select.textContent = '';
          variants.forEach((variant) => {
            const option = document.createElement('option');
            option.value = String(variant.id);
            option.textContent = variant.title;
            option.disabled = !variant.available;
            select.appendChild(option);
          });
          select.dataset.product = tile.dataset.productId;
        }

        const wanted = this.pickVariant(variants);
        if (wanted && select.value !== String(wanted.id)) select.value = String(wanted.id);
        if (wrap) wrap.hidden = variants.length < 2;
        this.updateSelectText();
      }

      updateSelectText() {
        const select = this.querySelector('[data-sbp-select]');
        const text = this.querySelector('[data-sbp-select-text]');
        if (!select || !text) return;
        const option = select.options[select.selectedIndex];
        text.textContent = option ? option.textContent : '';
      }

      updateButton(tile) {
        const variant = this.currentVariant(tile);
        const title = tile.dataset.productTitle || '';
        this.querySelectorAll('[data-sbp-name], [data-sbp-picked]').forEach((el) => {
          if (el.textContent !== title) el.textContent = title;
        });

        const shown = title + '|' + (variant ? variant.id : '');
        const previous = this.lastShown;
        this.lastShown = shown;
        this.applyMode();

        if (previous !== null && previous !== shown) {
          this.querySelectorAll('[data-sbp-half], [data-sbp-save]').forEach((el) => this.replay(el, 'is-bump'));
          if (previous.split('|')[0] !== title) {
            this.querySelectorAll('[data-sbp-name], [data-sbp-picked]').forEach((el) => this.replay(el, 'is-swap'));
          }
        }
      }

      replay(el, className) {
        if (!el || this.reduceMotion) return;
        el.classList.remove(className);
        void el.offsetWidth;
        el.classList.add(className);
        el.addEventListener('animationend', () => el.classList.remove(className), { once: true });
      }

      setupEntrance() {
        if (this.entranceDone || this.dataset.animEntrance !== 'true' || this.reduceMotion) return;

        const rect = this.getBoundingClientRect();
        const onScreen = rect.top < window.innerHeight * 0.6 && rect.bottom > 0;
        if (onScreen || !('IntersectionObserver' in window)) {
          this.entranceDone = true;
          this.timers.push(setTimeout(() => this.swipeHint(), 1400));
          return;
        }

        this.tiles().forEach((tile, index) => tile.style.setProperty('--sbp-delay', 120 + index * 70 + 'ms'));
        this.classList.add('sbp--enter');

        this.io = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            if (this.io) this.io.disconnect();
            this.io = null;
            this.entranceDone = true;
            requestAnimationFrame(() => this.classList.add('is-visible'));
            this.timers.push(setTimeout(() => this.classList.remove('sbp--enter', 'is-visible'), 1700));
            this.timers.push(setTimeout(() => this.swipeHint(), 1200));
          },
          { threshold: 0.35 }
        );
        this.io.observe(this);
      }

      swipeHint() {
        if (this.hinted || this.userTouched || this.reduceMotion || this.dataset.animEntrance !== 'true') return;
        const track = this.querySelector('.sbp__tiles');
        if (!track || track.scrollWidth <= track.clientWidth + 8 || track.scrollLeft > 0) return;
        this.hinted = true;
        track.scrollTo({ left: 48, behavior: 'smooth' });
        this.timers.push(
          setTimeout(() => {
            if (!this.userTouched) track.scrollTo({ left: 0, behavior: 'smooth' });
          }, 560)
        );
      }

      cartTarget() {
        const selectors = ['cart-icon', '.header-actions__cart-icon', '[data-cart-icon]', '#cart-icon-bubble', 'a[href$="/cart"]', 'button[aria-controls*="cart"]'];
        for (const selector of selectors) {
          let nodes = [];
          try {
            nodes = Array.from(document.querySelectorAll(selector));
          } catch (error) {
            continue;
          }
          const hit = nodes.find((el) => {
            if (this.contains(el)) return false;
            const r = el.getBoundingClientRect();
            return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth;
          });
          if (hit) return hit;
        }
        return null;
      }

      flyToCart(tile) {
        if (this.dataset.animFly !== 'true' || this.reduceMotion || !tile || this.closest('dialog')) return Promise.resolve();
        if (typeof Element.prototype.animate !== 'function') return Promise.resolve();
        const target = this.cartTarget();
        const media = tile.querySelector('.sbp__tile-media');
        if (!target || !media) return Promise.resolve();

        const from = media.getBoundingClientRect();
        const to = target.getBoundingClientRect();
        const clone = media.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('.sbp__check, .sbp__incart, .sbp__same').forEach((el) => el.remove());
        Object.assign(clone.style, {
          position: 'fixed',
          left: from.left + 'px',
          top: from.top + 'px',
          width: from.width + 'px',
          height: from.height + 'px',
          margin: '0',
          zIndex: '2147483000',
          pointerEvents: 'none',
          borderRadius: '8px',
          overflow: 'hidden',
          background: '#F3F2EE',
          boxShadow: '0 10px 28px rgba(0, 0, 0, 0.18)'
        });
        document.body.appendChild(clone);

        const dx = to.left + to.width / 2 - (from.left + from.width / 2);
        const dy = to.top + to.height / 2 - (from.top + from.height / 2);
        const lift = Math.min(90, Math.abs(dy) * 0.25 + 30);
        const flight = clone.animate(
          [
            { transform: 'translate(0px, 0px) scale(1)', opacity: 1 },
            { transform: 'translate(' + dx * 0.45 + 'px, ' + (dy * 0.45 - lift) + 'px) scale(0.72)', opacity: 1, offset: 0.45 },
            { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(0.18)', opacity: 0.3 }
          ],
          { duration: 560, easing: 'cubic-bezier(0.45, 0, 0.25, 1)' }
        );

        return new Promise((resolve) => {
          const safety = setTimeout(() => {
            clone.remove();
            resolve();
          }, 1500);
          flight.onfinish = () => {
            clearTimeout(safety);
            clone.remove();
            try {
              target.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.22)' }, { transform: 'scale(1)' }], { duration: 380, easing: 'cubic-bezier(0.3, 1.5, 0.5, 1)' });
            } catch (error) {
              /* no-op */
            }
            resolve();
          };
          flight.oncancel = () => {
            clearTimeout(safety);
            clone.remove();
            resolve();
          };
        });
      }

      fit() {
        const button = this.querySelector('[data-sbp-add]');
        const label = this.querySelector('.sbp__add-label');
        if (!button || !label || button.classList.contains('is-added')) return;
        this.classList.remove('is-tight');
        if (label.scrollWidth > label.clientWidth + 1) this.classList.add('is-tight');
      }

      onClick(event) {
        const tile = event.target.closest('[data-sbp-tile]');
        if (tile && this.contains(tile)) {
          event.preventDefault();
          const changed = this.selectedId !== tile.dataset.productId;
          this.selectedId = tile.dataset.productId;
          this.clearError();
          this.resetAdded();
          this.render();
          if (changed) this.replay(tile, 'is-popping');
          return;
        }

        const addButton = event.target.closest('[data-sbp-add]');
        if (addButton && this.contains(addButton)) {
          event.preventDefault();
          this.add(addButton);
        }
      }

      onChange(event) {
        const select = event.target.closest('[data-sbp-select]');
        if (!select || !this.contains(select)) return;
        event.stopPropagation();
        const option = select.options[select.selectedIndex];
        this.grindTouched = true;
        this.chosenGrind = option ? option.textContent : null;
        this.clearError();
        this.resetAdded();
        this.updateSelectText();
        const tile = this.selectedTile();
        if (tile) this.updateButton(tile);
      }

      onRootChange() {
        this.timers.push(setTimeout(this.render, 60));
      }

      onVariantUpdate(event) {
        const target = event.target;
        if (this.root && target instanceof Node && target !== document && !this.root.contains(target)) return;
        const resource = event.detail && event.detail.resource;
        if (resource && resource.title) this.lastMainTitle = resource.title;
        this.timers.push(setTimeout(this.render, 60));
        this.timers.push(setTimeout(this.render, 400));
      }

      route(path) {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        return root + path;
      }

      cartSectionIds() {
        const ids = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);
        return Array.from(new Set(ids)).slice(0, 5);
      }

      async add(button) {
        if (this.busy) return;
        const tile = this.selectedTile();
        if (!tile) return;
        const variant = this.currentVariant(tile);
        if (!variant) return;
        if (!variant.available) {
          this.showError(this.dataset.textSoldOut || 'That grind is sold out.');
          return;
        }

        this.busy = true;
        button.setAttribute('aria-busy', 'true');
        this.clearError();

        try {
          this.setCartCoffee(await this.fetchCart());
        } catch (error) {
          /* keep the last known cart state */
        }

        const bundle = this.isBundle();
        const mainItem = bundle ? this.mainItem() : null;
        const secondItem = { id: Number(variant.id), quantity: 1, properties: { _second_bag: 'Yes' } };
        const items = [secondItem];
        if (bundle && mainItem) items.push(mainItem);
        const addedQuantity = items.reduce((sum, item) => sum + item.quantity, 0);

        const bridge = this.loadCartEvents();
        const drawerSnapshots = Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map((el) => ({
          el: el,
          id: el.dataset.sectionId,
          html: el.innerHTML
        }));

        try {
          const body = { items: items };
          const sectionIds = this.cartSectionIds();
          if (sectionIds.length) {
            body.sections = sectionIds.join(',');
            body.sections_url = window.location.pathname;
          }

          const response = await fetch(this.route('cart/add.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(body)
          });
          const data = await response.json().catch(() => ({}));
          if (!response.ok || data.status) throw new Error(data.description || data.message || this.dataset.textError || 'Could not add to cart.');

          const addedText = this.querySelector('[data-sbp-added-text]');
          if (addedText) addedText.textContent = (bundle ? this.dataset.textAddedBoth : this.dataset.textAddedOne) || addedText.textContent;
          this.showAdded(button, tile);

          const drawerAutoOpens = Boolean(document.querySelector('cart-drawer-component[auto-open]'));
          const landed = drawerAutoOpens ? Promise.resolve() : this.flyToCart(tile);
          const cart = await this.fetchCart().catch(() => null);
          await landed;
          await this.notifyCart(await bridge, data, cart, items, addedQuantity);
          this.syncCartUI(cart, drawerSnapshots, await bridge);

          if (cart) this.setCartCoffee(cart);
          this.announce((tile.dataset.productTitle || '') + ' ' + (this.dataset.textAdded || 'added to cart'));
        } catch (error) {
          this.showError(error && error.message ? error.message : this.dataset.textError || 'Could not add to cart.');
        } finally {
          this.busy = false;
          button.removeAttribute('aria-busy');
        }
      }

      async fetchCart() {
        const response = await fetch(this.route('cart.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
        if (!response.ok) throw new Error('cart');
        return response.json();
      }

      setCartCoffee(cart) {
        const eligible = this.eligibleIds();
        const inCart = new Set();
        let count = 0;
        let min = null;
        ((cart && cart.items) || []).forEach((item) => {
          const productId = String(item.product_id);
          inCart.add(productId);
          if (!eligible.has(productId)) return;
          count += Number(item.quantity) || 0;
          const unit = Number(item.original_price != null ? item.original_price : item.price);
          if (isFinite(unit) && unit > 0 && (min === null || unit < min)) min = unit;
        });
        this.cartCoffee = count;
        this.cartMin = min;
        this.cartIds = inCart;
        this.syncInCart(inCart);
        this.applyMode();
      }

      loadCartEvents() {
        if (!SentierBagPicker.cartEvents) {
          SentierBagPicker.cartEvents = (async () => {
            const bridge = { standard: null, legacy: null };
            try {
              const standard = await import('@shopify/events');
              if (standard && standard.CartLinesUpdateEvent && typeof standard.CartLinesUpdateEvent.createCartFromAjaxResponse === 'function') {
                bridge.standard = standard.CartLinesUpdateEvent;
              }
            } catch (error) {
              /* Horizon before v4 has no standard events */
            }
            try {
              const legacy = await import('@theme/events');
              if (legacy && legacy.CartAddEvent) bridge.legacy = legacy.CartAddEvent;
            } catch (error) {
              /* no theme events module */
            }
            return bridge;
          })();
        }
        return SentierBagPicker.cartEvents;
      }

      async notifyCart(bridge, data, cart, items, addedQuantity) {
        const sections = (data && data.sections) || {};
        let notified = false;
        if (/[?&]sbp_debug=1/.test(window.location.search)) {
          console.info('[sentier-bag-picker] events', { standard: Boolean(bridge && bridge.standard), legacy: Boolean(bridge && bridge.legacy), sections: Object.keys(sections) });
        }

        if (bridge && bridge.standard && cart) {
          try {
            const result = {
              cart: bridge.standard.createCartFromAjaxResponse(cart),
              detail: {
                items: cart.items,
                source: 'product-form-component',
                sourceId: 'sentier-bag-picker',
                itemCount: addedQuantity,
                sections: sections,
                didError: false
              }
            };
            this.dispatchEvent(
              new bridge.standard({
                action: 'add',
                context: 'product',
                lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: item.quantity })),
                promise: Promise.resolve(result)
              })
            );
            notified = true;
          } catch (error) {
            notified = false;
          }
        }

        const legacyData = { source: 'product-form-component', itemCount: addedQuantity, sections: sections };
        if (bridge && bridge.legacy) {
          try {
            this.dispatchEvent(new bridge.legacy({}, 'sentier-bag-picker', legacyData));
            notified = true;
          } catch (error) {
            /* fall through */
          }
        }

        if (!notified) {
          this.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: {}, sourceId: 'sentier-bag-picker', data: legacyData } }));
        }
      }

      async syncCartUI(cart, snapshots, bridge) {
        const debug = /[?&]sbp_debug=1/.test(window.location.search);

        if (cart && typeof cart.item_count === 'number') {
          document.querySelectorAll('cart-icon').forEach((icon) => {
            if (typeof icon.renderCartBubble === 'function') {
              try {
                icon.renderCartBubble(cart.item_count, false);
              } catch (error) {
                if (debug) console.warn('[sentier-bag-picker] cart bubble', error);
              }
            }
          });
        }

        await new Promise((resolve) => setTimeout(resolve, 350));
        const stale = (snapshots || []).filter((snap) => snap.el.isConnected && snap.el.innerHTML === snap.html);
        if (debug) console.info('[sentier-bag-picker] cart sections', (snapshots || []).map((snap) => snap.id), 'stale:', stale.map((snap) => snap.id));
        if (!stale.length) return;

        let renderer = null;
        try {
          const mod = await import('@theme/section-renderer');
          renderer = mod && mod.sectionRenderer;
        } catch (error) {
          if (debug) console.warn('[sentier-bag-picker] section renderer', error);
        }
        if (!renderer || typeof renderer.renderSection !== 'function') return;

        for (const snap of stale) {
          try {
            await renderer.renderSection(snap.id, {
              cache: false,
              mode: bridge && bridge.standard && snap.el.hasAttribute('data-drawer') ? 'hydration' : 'full',
              injectStylesheet: Boolean(snap.el.querySelector('[data-cart-drawer-empty]'))
            });
          } catch (error) {
            if (debug) console.warn('[sentier-bag-picker] render', snap.id, error);
          }
        }
      }

      showAdded(button, tile) {
        button.classList.add('is-added');
        if (tile) tile.classList.add('is-in-cart');
        clearTimeout(this.addedTimer);
        this.addedTimer = setTimeout(() => this.resetAdded(), 2400);
      }

      resetAdded() {
        clearTimeout(this.addedTimer);
        const button = this.querySelector('[data-sbp-add]');
        if (button) button.classList.remove('is-added');
        this.fit();
      }

      showError(message) {
        const el = this.querySelector('[data-sbp-error]');
        if (!el) return;
        el.textContent = message;
        el.hidden = false;
        clearTimeout(this.errorTimer);
        this.errorTimer = setTimeout(() => this.clearError(), 6000);
      }

      clearError() {
        const el = this.querySelector('[data-sbp-error]');
        if (!el) return;
        el.hidden = true;
        el.textContent = '';
      }

      announce(message) {
        const live = this.querySelector('[data-sbp-live]');
        if (!live) return;
        live.textContent = '';
        requestAnimationFrame(() => {
          live.textContent = message;
        });
      }
    }

    customElements.define('sentier-bag-picker', SentierBagPicker);
  }
  } catch(e) { console.error(e); }
})();

})();
